import { ReactNode } from 'react';
import { EmployeeType } from '@prisma/client';
import { Descriptions, Space } from 'antd';
import Link from 'antd/es/typography/Link';

import { Popover, Tables } from '@app/web-components';

import { EmployeeTypeRenderer } from '../../atoms';
import { WorkerLink } from '../worker-link';

export type UserPopoverProps = {
  user: {
    name: string;
    employeeType: EmployeeType;
    enterpriseId: string;
    idsid: string | null;
    email: string | null;
    givenName: string;
    familyName: string;
    employeeRootRoleType: string | null;
    employeeRoleType: string | null;
    isActive: boolean;
  };
  children: ReactNode;
};

export const UserPopover = ({ user, children }: UserPopoverProps) => {
  if (!user) {
    return null;
  }

  return (
    <Popover.Popover2Modal
      placement="right"
      title={user.name}
      popoverWidth={600}
      popoverHeight="auto"
      content={
        <Space direction="vertical" size="large" style={{ paddingTop: 10, width: '100%' }}>
          <Descriptions bordered size="small" layout="horizontal" column={1}>
            <Descriptions.Item label="Active">
              <Tables.BooleanRenderer value={user.isActive} />
            </Descriptions.Item>
            <Descriptions.Item label="First Name">{user.givenName}</Descriptions.Item>
            <Descriptions.Item label="Last Name">{user.familyName}</Descriptions.Item>
            <Descriptions.Item label="Email">
              <Link href={`mailto:${user.email}`}>{user.email}</Link>
            </Descriptions.Item>
            <Descriptions.Item label="Employee Type">
              {<EmployeeTypeRenderer employeeType={user.employeeType} />}
            </Descriptions.Item>
            <Descriptions.Item label="Wwid / Enterprise ID">
              <WorkerLink enterpriseId={user.enterpriseId} />
            </Descriptions.Item>
            <Descriptions.Item label="Idsid">{user.idsid}</Descriptions.Item>
            <Descriptions.Item label="Root Role Type">{user.employeeRootRoleType}</Descriptions.Item>
            <Descriptions.Item label="Role Type">{user.employeeRoleType}</Descriptions.Item>
          </Descriptions>
        </Space>
      }
    >
      {children}
    </Popover.Popover2Modal>
  );
};
